import { createAction } from 'redux-actions'
import * as constants from './constants'

export const uploadCsv = createAction(constants.UPLOAD_CSV)
export const uploadCsvPending = createAction(constants.UPLOAD_CSV_PENDING)
export const uploadCsvFailed = createAction(constants.UPLOAD_CSV_FAILED)
export const uploadCsvCancelled = createAction(constants.UPLOAD_CSV_CANCELLED)
export const uploadCsvSuccess = createAction(constants.UPLOAD_CSV_SUCCESS)

export const startCsvImport = createAction(constants.START_CSV_IMPORT)
export const startCsvImportPending = createAction(constants.START_CSV_IMPORT_PENDING)
export const startCsvImportFailed = createAction(constants.START_CSV_IMPORT_FAILED)
export const startCsvImportSuccess = createAction(constants.START_CSV_IMPORT_SUCCESS)

export const clearCsv = createAction(constants.CLEAR_CSV)
export const setMapping = createAction(constants.SET_MAPPING)

export const setSelected = createAction(constants.SET_SELECTED)
export const toggleColumn = createAction(constants.TOGGLE_COLUMN)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/csv/actions.js